<template>
  <v-row class="my-0">
    <v-col class="pa-0">
      <div id="map">
        <v-text-field
          v-model="searchAddressInput"
          type="text"
          hide-details="auto"
          class="search_field"
          append-icon="mdi-magnify"
          @click:append="searchLocation"
          @keydown.enter="searchLocation"
          placeholder="場所を検索"
          solo
        />
        <gmap-map
          ref="gmap"
          :center="center"
          :zoom="zoom"
          style="width: 100%; height: 60vh"
          :options="{
            disableDefaultUI: false,
            scrollwheel: true,
            styles: mapStyles
          }"
          @click="unsetInfoDeviceId"
        >
          <gmap-info-window
            :options="infoOptions"
            :position="infoDevice.position"
            :opened="infoDeviceId !== ''"
            @closeclick="unsetInfoDeviceId"
          >
            <div class="card">
              <div class="card-content py-3 px-3">
                <div class="subtitle-1 mb-0">
                  {{ infoDevice.name }}
                </div>
                <div>
                  <v-btn
                    small
                    plain
                    class="px-0 py-0"
                    @click="$emit('openDevicePictureDialog')"
                  >
                    <v-icon small>mdi-camera</v-icon>
                    <span>センサ設置画像の表示</span>
                  </v-btn>
                </div>
                <v-switch
                  v-model="infoDevice.is_set"
                  class="mt-1"
                  dense
                  @change="changeIsSet"
                >
                  <template v-slot:label>
                    <p class="caption mb-0">通知 オフ / オン</p>
                  </template>
                </v-switch>
                <v-switch
                  v-show="infoDevice.is_alert"
                  v-model="infoDevice.is_notification_disabled"
                  class="mt-0"
                  dense
                  @change="changeIsNotificationDisabled"
                >
                  <template v-slot:label>
                    <p class="caption mb-0">
                      {{
                        alertDisabledTime(infoDevice.alert_disabled_time)
                      }}後まで通知をしない
                    </p>
                  </template>
                </v-switch>
                <p v-if="infoDevice.is_alert" class="my-1 caption">
                  ※通知オフで停止するとオンにし忘れることがありますので、「〇時間後まで通知をしない」をオンにして停止してください。
                </p>
              </div>
            </div>
          </gmap-info-window>
          <div v-for="d in devices" :key="d.id">
            <gmap-marker
              dense
              :position="d.position"
              :icon="selectIcon(d)"
              @click="setInfoDeviceId(d.id)"
            ></gmap-marker>
          </div>
        </gmap-map>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import Vue from 'vue'
import { mapGetters, mapActions } from 'vuex'
import * as VueGoogleMaps from 'vue2-google-maps'
import { postUserDevice, putUserDevice, deleteUserDevice } from '@/api'
import markImage from '@/assets/pin-set.svg'
import markImageNotset from '@/assets/pin-notset.svg'
import markImageAlert from '@/assets/pin-alert.svg'
import { GOOGLE_MAPS_API_KEY, GOOGLE_MAPS_API_VERSION } from '@/constants'
import mapStyle from '@/styles/map-style'

Vue.use(VueGoogleMaps, {
  load: {
    key: GOOGLE_MAPS_API_KEY,
    v: GOOGLE_MAPS_API_VERSION
  }
})

const maxZoomValue = 18
const searchZoomValue = 11

export default {
  name: 'DeviceMap',
  data() {
    return {
      // map settings
      mapStyles: mapStyle,
      // map marker img
      iconSet: markImage,
      iconNoSet: markImageNotset,
      iconAlert: markImageAlert,
      // a default center for the map
      center: { lat: 34.9950044, lng: 135.7364171 },
      infoWinOpen: false,
      // optional: offset infowindow so it visually sits nicely on top of our marker
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35
        }
      },
      zoom: maxZoomValue,
      initialize: true,
      searchAddressInput: ''
    }
  },
  computed: {
    ...mapGetters(['devices', 'infoDevice', 'infoDeviceId', 'reloadMap'])
  },
  watch: {
    devices() {
      if (this.initialize) {
        this.initMap(false)
        this.initialize = false
      }
    },
    reloadMap(isReload) {
      if (isReload) {
        this.initMap(isReload)
        this.completeReloadMap()
      }
    }
  },
  mounted() {
    if (this.devices.length > 0) {
      this.initMap(false)
      this.initialize = false
    }
  },
  methods: {
    ...mapActions([
      'setInfoDeviceId',
      'unsetInfoDeviceId',
      'updateDeviceBy',
      'completeReloadMap'
    ]),
    initMap(isReload) {
      console.log('init map...')
      this.$refs.gmap.$mapPromise.then(map => {
        const bounds = new google.maps.LatLngBounds()
        const boundsAll = new google.maps.LatLngBounds()
        let find = false
        this.devices.map(d => {
          if (d.is_set) {
            bounds.extend(d.position)
            find = true
          }
          boundsAll.extend(d.position)
        })
        if (!isReload) {
          if (find) {
            map.fitBounds(bounds)
          } else {
            map.fitBounds(boundsAll)
          }
          map.getZoom() > this.zoom && map.setZoom(this.zoom)
        }
      })
      if (this.$route.query.device_id !== undefined) {
        const found = this.devices.findIndex(
          d => d.id === this.$route.query.device_id
        )
        if (found !== -1) {
          this.setInfoDeviceId(this.$route.query.device_id)
        }
      }
    },
    selectIcon(device) {
      if (device.is_alert) {
        return this.iconAlert
      }
      if (device.is_set) {
        return this.iconSet
      }
      return this.iconNoSet
    },
    async changeIsSet(isSet) {
      this.updateDeviceBy({
        id: this.infoDeviceId,
        key: 'is_set',
        value: isSet
      })
      try {
        if (isSet) {
          await postUserDevice(this.$route.params.provider, this.infoDeviceId)
        } else {
          await deleteUserDevice(this.$route.params.provider, this.infoDeviceId)
        }
      } catch (e) {
        console.error(e)
        alert('サーバエラーが発生しました。ログイン画面に遷移します。')
        this.$router.push('/auth/sign-out')
        return
      }
    },
    async changeIsNotificationDisabled(isNotificationDisabled) {
      this.updateDeviceBy({
        id: this.infoDeviceId,
        key: 'is_notification_disabled',
        value: isNotificationDisabled
      })
      try {
        await putUserDevice(
          this.$route.params.provider,
          this.infoDeviceId,
          isNotificationDisabled,
          this.infoDevice.alert_disabled_time
        )
      } catch (e) {
        console.error(e)
        alert('サーバエラーが発生しました。ログイン画面に遷移します。')
        this.$router.push('/auth/sign-out')
        return
      }
    },
    alertDisabledTime(second) {
      const min = Math.floor(second / 60) % 60
      const hour = Math.floor(second / 3600)
      let time = ''
      if (hour > 0) {
        time += hour + '時間 '
      }
      if (min > 0) {
        time += min + '分'
      }
      return time
    },
    // searchAddressInput の内容から検索し、マップを移動させる
    searchLocation(event) {
      // 日本語入力中のEnterは無視する
      if (event.keyCode && event.keyCode !== 13) {
        return
      }
      if (this.searchAddressInput.length === 0) {
        return
      }

      // 検索にマッチした最初の場所にマップを移動させる
      const geocoder = new google.maps.Geocoder()
      geocoder.geocode(
        { address: this.searchAddressInput },
        (results, status) => {
          if (status === 'OK') {
            this.$refs.gmap.$mapObject.setCenter({
              lat: results[0].geometry.location.lat(),
              lng: results[0].geometry.location.lng()
            })
            this.$refs.gmap.$mapObject.setZoom(searchZoomValue)
          } else if (status === 'ZERO_RESULTS') {
            alert('検索結果はありませんでした。')
          }
        }
      )
    }
  }
}
</script>

<style lang="scss" scoped>
$search_field_width: 350px;
$margin_x: 10px;

.search_field {
  position: absolute;
  top: 60px;
  margin: 0 $margin_x !important;
  z-index: 1;
  width: $search_field_width;
}

// スマートフォン表示では「地図｜航空写真」に重なるように位置を移動させ、横幅を調整する
@media (max-width: 480px) {
  .search_field {
    top: 10px;
    width: 200px;
  }
}
</style>
